<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="fitnessSession.id === null">{{ 'NEWFITNESSSESSION' | translate }}</span>
            <span *ngIf="fitnessSession.id !== null">{{ 'EDITFITNESSSESSION' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="fitnessSessionForm" id="fitnessSessionForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="fitnessSessionForm" >
            <input type="hidden" name="id" id="fitnessSessionId" formControlName="id" />
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="fitnessSessionName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessSessionForm.controls['name'].invalid && (fitnessSessionForm.controls['name'].dirty || fitnessSessionForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessSessionForm.controls['name'].errors !== null">
                  <div *ngIf="fitnessSessionForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionNameAr" formControlName="nameAr" type="text" pInputText [required]="false"> 
                      <label for="fitnessSessionNameAr" class="">{{ 'NAMEAR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionNameFr" formControlName="nameFr" type="text" pInputText [required]="false"> 
                      <label for="fitnessSessionNameFr" class="">{{ 'NAMEFR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="fitnessSessionStartTime" formControlName="startTime" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="true" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="fitnessSessionStartTime" class="req">{{ 'STARTTIME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessSessionForm.controls['startTime'].invalid && (fitnessSessionForm.controls['startTime'].dirty || fitnessSessionForm.controls['startTime'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessSessionForm.controls['startTime'].errors !== null">
                  <div *ngIf="fitnessSessionForm.controls['startTime'].errors.required">
                   {{ 'STARTTIMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessSessionFitnessClassId" [autoDisplayFirst]="false" formControlName="fitnessClass" [options]="fitnessSessionsColumnsService.fitnessClasses" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessSessionFitnessClassId" class="req">{{ 'FITNESSCLASS' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessSessionForm.controls['fitnessClass'].invalid && (fitnessSessionForm.controls['fitnessClass'].dirty || fitnessSessionForm.controls['fitnessClass'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessSessionForm.controls['fitnessClass'].errors !== null">
                  <div *ngIf="fitnessSessionForm.controls['fitnessClass'].errors.required">
                   {{ 'FITNESSCLASSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-user-secret"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="fitnessSessionCoachId" [autoDisplayFirst]="false" formControlName="coach" [options]="fitnessSessionsColumnsService.coaches" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="fitnessSessionCoachId" class="req">{{ 'COACH' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="fitnessSessionForm.controls['coach'].invalid && (fitnessSessionForm.controls['coach'].dirty || fitnessSessionForm.controls['coach'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessSessionForm.controls['coach'].errors !== null">
                  <div *ngIf="fitnessSessionForm.controls['coach'].errors.required">
                   {{ 'COACHREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-link"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionPushStreamUrl" formControlName="pushStreamUrl" type="text" pInputText [required]="false"> 
                      <label for="fitnessSessionPushStreamUrl" class="">{{ 'PUSHSTREAMURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionPushStreamName" formControlName="pushStreamName" type="text" pInputText [required]="false"> 
                      <label for="fitnessSessionPushStreamName" class="">{{ 'PUSHSTREAMNAME' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-link"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionPublicStreamUrl" formControlName="publicStreamUrl" type="text" pInputText [required]="false"> 
                      <label for="fitnessSessionPublicStreamUrl" class="">{{ 'PUBLICSTREAMURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-link"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="fitnessSessionVodUrl" formControlName="vodUrl" type="text" pInputText [required]="false"> 
                      <label for="fitnessSessionVodUrl" class="">{{ 'VODURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="fitnessSessionRecordingEnabled" formControlName="recordingEnabled" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="fitnessSessionRecordingEnabled" class="p-d-inline-block p-ml-2 req">{{ 'RECORDINGENABLED' | translate }}</label>
                </div>
                <div *ngIf="fitnessSessionForm.controls['recordingEnabled'].invalid && (fitnessSessionForm.controls['recordingEnabled'].dirty || fitnessSessionForm.controls['recordingEnabled'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessSessionForm.controls['recordingEnabled'].errors !== null">
                  <div *ngIf="fitnessSessionForm.controls['recordingEnabled'].errors.required">
                   {{ 'RECORDINGENABLEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="fitnessSessionIsPublished" formControlName="isPublished" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="fitnessSessionIsPublished" class="p-d-inline-block p-ml-2 req">{{ 'ISPUBLISHED' | translate }}</label>
                </div>
                <div *ngIf="fitnessSessionForm.controls['isPublished'].invalid && (fitnessSessionForm.controls['isPublished'].dirty || fitnessSessionForm.controls['isPublished'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="fitnessSessionForm.controls['isPublished'].errors !== null">
                  <div *ngIf="fitnessSessionForm.controls['isPublished'].errors.required">
                   {{ 'ISPUBLISHEDREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKFITNESSSESSIONS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="fitnessSession.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!fitnessSessionForm.valid || disableSubmit"> <!--  [disabled]="fitnessSessionForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!fitnessSessionForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

